import React from 'react';
import { AppBar, Toolbar, Button, Box } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import logo from '../images/logo.png';

const NavigationBar: React.FC = () => {
  const location = useLocation();

  const getButtonStyle = (path: string) => ({
    color: 'inherit',
    textDecoration: location.pathname === path ? 'underline' : 'none',
    fontWeight: location.pathname === path ? 'bold' : 'normal',
    textDecorationColor: 'white',
  });

  return (
    <AppBar position="fixed" sx={{ width: '100%', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          <Link to="/">
            <img src={logo} alt="ADS Lab Logo" style={{ height: '35px', marginRight: '10px' }} />
          </Link>
        </Box>
        <Box>
          <Button color="inherit" component={Link} to="/" sx={getButtonStyle('/')}>Home</Button>
          <Button color="inherit" component={Link} to="/research" sx={getButtonStyle('/research')}>Research</Button>
          <Button color="inherit" component={Link} to="/publications" sx={getButtonStyle('/publications')}>Publications</Button>
          <Button color="inherit" component={Link} to="/members" sx={getButtonStyle('/members')}>Members</Button>
          <Button color="inherit" component={Link} to="/gallery" sx={getButtonStyle('/gallery')}>Gallery</Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavigationBar;
